import { useRef } from "react";

const linkIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="13" height="13" style="display: inline-block; vertical-align: middle;">
      <path d="M432 320h-32a16 16 0 0 0-16 16v96H64V128h96a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16H48A48 48 0 0 0 0 112v336a48 48 0 0 0 48 48h336a48 48 0 0 0 48-48V336a16 16 0 0 0-16-16z" fill="currentColor" stroke="currentColor" stroke-width="20"/>
      <path d="M488 0H328a24 24 0 0 0-17 41l35 35L183 239a24 24 0 0 0 0 34l22 22a24 24 0 0 0 34 0L402 132l35 35a24 24 0 0 0 41-17V24a24 24 0 0 0-24-24z" fill="currentColor"/>
    </svg>
`;

export const useInfoWindow = (map, mapsLib) => {
    const infoWindowRef = useRef(null);

    const init = () => {
        if (!mapsLib || !map) return;
        infoWindowRef.current ??= new mapsLib.InfoWindow();
    };

    const resolveTemplate = (text, context = {}) => {
        if (typeof text !== "string") return "-";

        return text.replace(/\$\{(.*?)\}/g, (_, key) => {
            return context[key.trim()] ?? "-";
        });
    };

    const buildContent = ({title = "Detalhamento", fields = [], footerButton = true, context = {}}) => {
        const lines = fields
            .map((f) => {
                const value = resolveTemplate(f.value ?? f.template, context);

                return `
                    <div style="margin-bottom:4px;">
                        ${value}
                    </div>
                `;
            })
            .join("");

        return `
            <div style="min-width: 220px; position: relative; padding: 12px;">
                <button id="infowindow-close"> × </button>
                <h4 style="margin: 6px 0 12px 0; font-size: 15px">${title}</h4>

                ${lines}

                ${
                    footerButton
                        ? `
                            <div style="margin: 16px 0 12px 0; height: 1.5px; background-color: #D8D8D8;"></div>
                            <div style="display: flex; justify-content: flex-end; transform: translateY(5px);">
                                <button id="location-open" class="street-view-button" style="display: flex; align-items: center; gap: 6px;">
                                    <div style="transform: translateY(-1px)">${linkIcon}</div>
                                    <span>Abrir no Street view</span>
                                </button>
                            </div>
                        `
                    : ""
                }
            </div>
        `;
    };

    const openInfoWindow = (marker, config) => {
        const iw = infoWindowRef.current;
        if (!iw) return;

        const lat = marker.originalPosition.lat();
        const lng = marker.originalPosition.lng();

        iw.close();

        iw.setContent(
            buildContent({
                title: config.title,
                fields: config.fields,
                context: {
                    lat,
                    lng,
                    ...(config.context || {})
                }
            })
        );

        iw.open({ map, anchor: marker });

        google.maps.event.addListenerOnce(iw, "domready", () => {
            document.getElementById("infowindow-close")?.addEventListener("click", () => {
                iw.close();
            });

            document.getElementById("location-open")?.addEventListener("click", () => {
                window.open(`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat},${lng}`, "_blank");
            });
        });
    };

    const close = () => {
        infoWindowRef.current?.close();
    };

    return { init, openInfoWindow, close, infoWindowRef };
};